import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LeadGeneration from "../../../components/LeadGeneration";
import config from "../../../util/config";
import axios from "axios";
import LeadGenCtaBtn from "../../../features/lead-generation/LeadGenCtaBtn";
import { BaseURL, BaseURLAuth } from "../../../services/api";

const ExamCard = ({ data }: any) => {
  const navigate = useNavigate();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const isMediumDevice = window.innerWidth >= 768;

  const handlePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const { pathname } = useLocation();
  const [wishlistData, setWishlistData] = useState<{ examId: number }[]>([]);

  // Fetch wishlist data
  const fetchWishlistData = () => {
    const userId = JSON.parse(localStorage.getItem("user") ?? "{}")?.userId;
    const accessToken = localStorage.getItem("accessToken");
    if (userId) {
      BaseURL.get(`/api/wishlist/category/${userId}?category=exam`, {
        headers: {
          Authorization: accessToken ? `${accessToken}` : "",
        },
      })
        .then((response) => {
          setWishlistData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching wishlist data:", error);
        });
    }
  };

  useEffect(() => {
    fetchWishlistData();
  }, []);

  const handleWishList = (examId: number) => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/secure/login", { state: { sourcePagePath: pathname } });
    } else {
      const toggleWishlist = async () => {
        try {
          if (JSON.parse(localStorage.getItem("user") ?? "{}")?.userId) {
            const apiUrl =
              wishlistData.find((exam) => exam.examId === examId) !== undefined
                ? config.apiUrl + "/api/wishlist/remove"
                : config.apiUrl + "/api/wishlist/add";

            const response = await BaseURLAuth.post(
              apiUrl,
              {
                categoryName: "exam",
                categoryId: examId,
                userId: JSON.parse(user)?.userId,
              },
              {
                headers: {
                  Authorization: localStorage.getItem("accessToken"),
                  "X-Auth-Token":
                    "e711724f44c71abf0c2794572472ed6edcea55a351f6428fe67060a692aa9316",
                },
              }
            );
            if (response.data) {
              fetchWishlistData();
            } else {
              console.error("Error toggling wishlist:", response.statusText);
            }
          }
        } catch (error) {
          console.error("Error toggling wishlist:", error);
        }
      };
      toggleWishlist();
    }
  };

  return (
    <>
      {data &&
        data?.map((card: any) => {
          return (
            <div
              key={card.examId}
              className="relative flex flex-row md:gap-10 md:w-full rounded-md bg-[#fff]  p-[21px] max-md:flex-col justify-between w-full"
              style={{
                boxShadow: "0px 2px 10px 2px rgba(0, 0, 0, 0.06)",
              }}
            >
              <div className="flex flex-col lg:flex-row justify-between w-full gap-4 md:gap-8 items-center">
                <div className="flex flex-col gap-2 w-full">
                  <div className="flex flex-row gap-6 ">
                    <div
                      className="md:p-2 rounded-md max-md:h-[49px] max-md:w-[49px] max-md:p-1"
                      style={{
                        border: "1px solid #E5E5E5",
                      }}
                    >
                      <img
                        src="/images/exam-jee-icon.jpg"
                        alt="exam-icon"
                        className="rounded max-md:w-[40px] max-md:h-[40px]"
                      />
                    </div>
                    <div className="flex flex-col gap-[18px] py-1">
                      <div className="flex">
                        <h3
                          className={`text-[#181A27] font-bold text-lg ${
                            !isMediumDevice ? "w-[210px]" : ""
                          }`}
                        >
                          <Link to={`/exam-details/${card.name}`}>
                            {card.title}
                          </Link>
                          <span className="text-[#00B489] ml-1 text-base font-semibold md:hidden">
                            • {card.mode}
                          </span>
                        </h3>
                        <span className="text-[#00B489] ml-1 text-base font-semibold max-md:hidden">
                          • {card.mode}
                        </span>

                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            handleWishList(card.examId);
                          }}
                          className={`absolute right-[50px] min-max-xss:right-5 min-max-xs:right-7 rounded transition-colors duration-300 ${
                            isClicked ? "" : ""
                          }`}
                        >
                          <FontAwesomeIcon
                            icon={faHeart}
                            color={
                              wishlistData?.some(
                                (item) => item.examId === card.examId
                              )
                                ? "#EC1A3B" // red heart
                                : "#FFF" // white heart
                            }
                            stroke="#EC1A3B"
                            size="lg"
                            strokeWidth={40}
                          />
                        </button>
                      </div>
                      <div className="flex flex-wrap gap-2 max-md:hidden">
                        <div className="flex items-center gap-1">
                          <img src="/images/exam-time-icon.jpg" alt="" />
                          <span className="text-[#181A27] font-normal text-sm px-1">
                            {card.mode}
                          </span>
                        </div>
                        <span className="text-[#ccc] w-[2px] pr-2">|</span>
                        <div className="flex items-center gap-1">
                          <img src="/images/exam-openbook-icon.jpg" alt="" />
                          <span className="text-[#181A27] font-normal text-sm px-1">
                            {card.level}
                          </span>
                        </div>
                        <span className="text-[#ccc] w-[2px] pr-1">|</span>
                        <div className="flex items-center gap-1">
                          <img src="/images/exam-timeremove-icon.jpg" alt="" />
                          <span className="text-[#181A27] font-normal text-sm px-1">
                            {card.frequency}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1 md:hidden text-[13px]">
                    <div className="flex items-center ">
                      <img src="/images/exam-time-icon.jpg" alt="" />
                      <span className="text-[#181A27] font-normal  px-1">
                        {card.mode}
                      </span>
                    </div>
                    <span className="text-[#ccc] w-[2px] pr-2">|</span>
                    <div className="flex items-center ">
                      <img src="/images/exam-openbook-icon.jpg" alt="" />
                      <span className="text-[#181A27] font-normal  px-1">
                        {card.level}
                      </span>
                    </div>
                    <span className="text-[#ccc] w-[2px] pr-1">|</span>
                    <div className="flex items-center ">
                      <img src="/images/exam-timeremove-icon.jpg" alt="" />
                      <span className="text-[#181A27] font-normal  px-1">
                        {card.frequency}
                      </span>
                    </div>
                  </div>

                  <div className="flex  py-[17px]  min-max-xss:w-[300px] min-max-xs:w-[350px] ">
                    <table className=" bg-white border border-[#D1D1D1]">
                      <thead>
                        <tr className="border-b border-[#D1D1D1]">
                          <td className="py-2 border-r border-[#D1D1D1] px-4  text-left text-base font-medium text-[#173CBA] ">
                            Application Open
                          </td>
                          <td className="py-2 px-4 text-left text-sm font-medium text-[#000]">
                            {card.application.opendDates} (Application Cost:
                            {card.application.fees}/-)
                          </td>
                        </tr>
                        <tr className="border-b border-[#D1D1D1]">
                          <td className="py-2 border-r border-[#D1D1D1] px-4 text-left text-base font-medium text-[#173CBA] ">
                            Exam Dates
                          </td>
                          <td className="py-2 px-4 text-left text-sm font-medium text-[#000]">
                            {card?.application?.examDate}
                          </td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  {/* <div className="flex flex-col gap-3 md:hidden mb-3 w-[130px]">
                    <LeadGenCtaBtn
                      pageName="exam-landing"
                      ctaName={card.title}
                      className="button-styles green-bg items-center rounded-none hover:bg-blue whitespace-nowrap"
                    >
                      Apply Now{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="12"
                        viewBox="0 0 15 12"
                        fill="none"
                      >
                        <path
                          d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403806 8.98959 0.403806 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6.75L14 6.75L14 5.25L1 5.25L1 6.75Z"
                          fill="white"
                        />
                      </svg>
                    </LeadGenCtaBtn>
                  </div> */}

                  <div
                    className="flex flex-wrap text-[#69678B] text-sm font-normal capitalize list-none"
                    style={{
                      padding: "15px 32.75px 1px 0px",
                      borderTop: "1px solid #CCC",
                    }}
                  >
                    <Link
                      to={`/exam-details/${card.name}#overview`}
                      className="md:px-2 max-md:px-1 max-md:py-1"
                    >
                      Overview
                    </Link>
                    <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                      |
                    </span>
                    <Link
                      to={`/exam-details/${card.name}#eligibility-criteria`}
                      className="md:px-2 max-md:px-1 max-md:py-1"
                    >
                      Eligibility
                    </Link>
                    <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                      |
                    </span>
                    <Link
                      to={`/exam-details/${card.name}#application`}
                      className="md:px-2 max-md:px-1 max-md:py-1"
                    >
                      Application Process
                    </Link>
                    <span className="text-[#ccc] font-normal text-sm px-1 max-md:hidden max-md:py-1">
                      |
                    </span>
                    <Link
                      to={`/exam-details/${card.name}#exam-pattern`}
                      className="md:px-2 max-md:px-1 max-md:py-1"
                    >
                      Exam Pattern
                    </Link>
                    <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                      |
                    </span>
                    <Link
                      to={`/exam-details/${card.name}#result-n-cut-off`}
                      className="md:px-2 max-md:px-1 max-md:py-1"
                    >
                      Results
                    </Link>
                    <span className="text-[#ccc] font-normal text-sm px-1 max-md:py-1">
                      |
                    </span>
                  </div>
                </div>

                <div className="flex flex-col gap-3">
                  <LeadGenCtaBtn
                    pageName="exam-results"
                    ctaName={card.title}
                    className="button-styles green-bg items-center rounded-none hover:bg-blue whitespace-nowrap !py-3 !px-6"
                  >
                    Apply Now{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="12"
                      viewBox="0 0 15 12"
                      fill="none"
                    >
                      <path
                        d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75L1 5.25ZM14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403806 8.98959 0.403806 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM1 6.75L14 6.75L14 5.25L1 5.25L1 6.75Z"
                        fill="white"
                      />
                    </svg>
                  </LeadGenCtaBtn>
                  <button
                    onClick={handlePopup}
                    className="hidden rounded-md bg-[#fff] items-center text-[#173CBA] md:px-[15px] md:py-[6.6px] max-md:px-[8px] max-md:py-[3px]"
                    style={{
                      border: "1.128px solid #173CBA",
                    }}
                  >
                    Get Alerts
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      className="ml-[6px]"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.88903 4.81669V5.31144C6.35976 6.34862 4.59269 9.7553 4.65681 12.7078L4.6568 14.3476C3.36201 16.0121 3.43819 18.494 6.66852 18.494H8.88903C8.88903 19.1741 9.15409 19.8264 9.62592 20.3074C10.0977 20.7883 10.7376 21.0585 11.4048 21.0585C12.0721 21.0585 12.7119 20.7883 13.1837 20.3074C13.6555 19.8264 13.9205 19.1741 13.9205 18.494H16.1472C19.3713 18.494 19.4181 16.0069 18.1235 14.3424L18.1595 12.71C18.2246 9.75414 16.4541 6.34439 13.9205 5.30868V4.81669C13.9205 4.13654 13.6555 3.48425 13.1837 3.00332C12.7119 2.52239 12.0721 2.2522 11.4048 2.2522C10.7376 2.2522 10.0977 2.52239 9.62592 3.00332C9.15409 3.48425 8.88903 4.13654 8.88903 4.81669ZM12.2434 4.81669C12.2434 4.81669 12.2428 4.85136 12.2418 4.86859C11.9687 4.83433 11.6905 4.81669 11.4082 4.81669C11.1236 4.81669 10.8431 4.83462 10.5678 4.86942C10.5667 4.85192 10.5662 4.83433 10.5662 4.81669C10.5662 4.58998 10.6545 4.37255 10.8118 4.21224C10.9691 4.05192 11.1824 3.96186 11.4048 3.96186C11.6272 3.96186 11.8405 4.05192 11.9978 4.21224C12.155 4.37255 12.2434 4.58998 12.2434 4.81669ZM10.5662 18.494C10.5662 18.7207 10.6545 18.9382 10.8118 19.0985C10.9691 19.2587 11.1824 19.3488 11.4048 19.3488C11.6272 19.3488 11.8405 19.2587 11.9978 19.0985C12.155 18.9382 12.2434 18.7207 12.2434 18.494H10.5662ZM16.1472 16.7843C16.8636 16.7843 17.2501 15.9277 16.7839 15.3732C16.5573 15.1038 16.4366 14.761 16.4444 14.4092L16.4827 12.6716C16.5467 9.76923 14.2561 6.52635 11.4082 6.52635C8.56087 6.52635 6.27056 9.76815 6.33358 12.6699L6.37136 14.4094C6.379 14.7612 6.2583 15.1039 6.03181 15.3732C5.56555 15.9277 5.95206 16.7843 6.66852 16.7843H16.1472ZM16.1137 3.38247C16.4095 2.95568 16.9955 2.84952 17.4223 3.14538C18.5015 3.89348 19.7957 5.68762 20.5024 7.81191C20.6663 8.30467 20.3997 8.83703 19.907 9.00095C19.4141 9.16488 18.8818 8.8983 18.7178 8.40553C18.0971 6.53955 16.9997 5.14074 16.3509 4.69098C15.9241 4.39512 15.8179 3.80928 16.1137 3.38247ZM5.25345 3.14538C5.68026 2.84952 6.2661 2.95568 6.56195 3.38247C6.85781 3.80928 6.75166 4.39512 6.32486 4.69098C5.67602 5.14074 4.57855 6.53955 3.95781 8.40553C3.79389 8.8983 3.26153 9.16488 2.76876 9.00095C2.27598 8.83703 2.0094 8.30467 2.17333 7.81191C2.87999 5.68762 4.17425 3.89348 5.25345 3.14538Z"
                        fill="#173CBA"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default ExamCard;
